import { type FunctionComponent, useContext } from 'react';
import { ConfigurationContext } from '../../contexts/config.context';
import { renderRichContent } from './tour-tooltip.component';

export const ChooseOrgContent: FunctionComponent = () => {
  const { config } = useContext(ConfigurationContext);
  // Assumes every app user can see Sample Estate; other tenants have no such org.
  const recommendation =
    config.name === 'app' ? ' — we recommend **Sample Estate** to start' : '';
  return renderRichContent(
    `Each organization is a group of repositories you can run recipes against.\n\n**Select an organization** to continue${recommendation}.\n\nYou can switch anytime from this same selector.`
  );
};
